<div  *ngIf="reportType == 'InDetail-booksellerledger'">
    
    <div class="container" id="print-section" style="margin-top: 50px;margin-left: 30px;">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="4" style="border:none;font-size: large;" class="br-bottom br-top br-left br-right">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक -पुस्तक विभाग </th>
                    <th colspan="2" style="border:none;font-size:medium;padding: 0px 14px !important;" class="br-bottom  br-top br-right">Book Seller Ledger - In Details</th>
                    <th colspan="3" style="border:none" class="br-bottom  br-top br-right"> Date : From {{ startDate | date: 'dd-MM-yyyy' }} - To {{ endDate | date: 'dd-MM-yyyy' }}</th>                
                    <th colspan="2" style="border:none" class="br-bottom br-top br-right">दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}  </th>
                </tr>

                <tr>
                    <th colspan="3"
    style="font-weight:700; text-align:center; font-size:large;
           border-right:3px solid #000 !important;">
  डेबिट
</th>

                    <th colspan="8" style="border:none;font-weight: bolder;text-align:center;font-size: large; " class="br-bottom br-right ">क्रेडिट </th>
                    </tr>
              
                <tr>
                    <th colspan="1" style="border:none ; font-size: small;width:0%;text-align:center;" class="br-bottom  br-left br-right">Invoice<br>No</th>
                    <th colspan="1" style="border:none ; font-size: small;width:0%; text-align:center;" class="br-bottom br-right">Invoice<br>Date</th>
                    <th colspan="1" style="border:none ;text-align:center; font-size: small;border-right:3px solid black !important;" class="br-bottom ">Invoice<br>Amount</th>
                    <th colspan="1" style="border:none ;text-align:center; font-size: small;" class="br-bottom br-right">Receipt No</th>
                    <th colspan="1" style="border:none ;text-align:center; font-size: small;" class="br-bottom br-right">Receipt<br>Date</th>
                    <th colspan="1" style="border:none ;text-align:center; font-size: small;" class="br-bottom br-right">Credit Vocher</th>
                    <th colspan="1" style="border:none ;text-align:center;font-size: small;" class="br-bottom br-right">Bank Details</th>
                    <th colspan="1" style="border:none ;text-align:center; font-size: small; width:0%;"  class="br-bottom br-right">Invoice<br>Number</th>
                    <th colspan="1" style="border:none ;text-align:center; font-size: small;" class="br-bottom br-right">Received<br>Amount</th>
                    <th colspan="1" style="border:none ;text-align:center; font-size: small;" class="br-bottom br-right">Cr.Note<br>Amt.</th>
                    <th colspan="1" style="border:none ;text-align:center; font-size: small;" class="br-bottom br-right">Balance</th>
                </tr>   
            </thead>
            <tbody *ngFor="let data of getpersonalleddata; let i = index">
                <tr>
                    <td colspan="11" style="font-size: 18px;border: none;text-align: left; font-weight: bolder;"class="br-right br-left" >Book Seller Name :  <span>{{data.book_seller_name}}</span></td>
                </tr>
                <tr>
                    <td colspan="2" style="border:none;font-weight: bold; font-size: small; " class="br-bottom br-left br-top">Opening Balance</td>
                    <td colspan="9" style="border:none;text-align: end; font-weight: bold;" class="br-bottom br-right br-top">{{data.opening_bal}} येणे</td>
                </tr>
               
                <tr *ngFor="let data1 of data.rep_data; let k = index">
                    <td colspan="1" style="border:none;font-weight: bold; font-size: small;"  class="br-right br-left br-bottom">{{data1.invoice_no}}</td>
                    <td colspan="1" style="border:none;font-weight: bold; font-size: small;"  class=" br-right br-bottom">{{ data1.invoice_date | date:'dd-MM-yyyy' }}</td>
<td colspan="1" 
    style="border:none; text-align:end; font-weight:bold;width: 0%; font-size:14px; border-right:3px solid black;" 
    class="br-bottom  br-right-4 ">
  {{data1.net_amt}}
</td>

                    <td colspan="1"
    style="border:none;font-weight:bolder;font-size:small;width:0%;"
    class="br-right br-bottom">
    {{ !data1.rcpt_no && data1.credit_voc ? data1.credit_voc : data1.rcpt_no }}
</td>
                    <!-- <td colspan="1" style="border:none; text-align: center; font-weight: bold; font-size:small;" class=" br-right br-bottom">{{data1.rcpt_date}}</td> -->
     <td colspan="1"
    style="border:none; text-align:center; font-weight:bold; font-size:small;"
    class="br-right br-bottom">
    {{ (data1.rcpt_no ? data1.rcpt_date : data1.voc_date) | date:'dd-MM-yyyy' }}
</td>
                    <td colspan="1" style="border:none;text-align: center; font-weight: bold; font-size: small;" class=" br-right br-bottom">
                        <ng-container *ngIf="data1.voucher_no">
                            {{ data1.voucher_no }}
                        </ng-container>
                        <!-- <ng-container *ngIf="data1.voc_date">
                            <br>{{ data1.voc_date }}
                        </ng-container> -->
                    </td>
                    <td colspan="1" style="border:none;font-weight: bold; font-size: small;" class="br-right br-bottom">
                        <ng-container *ngIf="data1.cheque_no || data1.pymt_options">
                          Cheque No: {{ data1.cheque_no }}
                        </ng-container>
                      </td>
                    <!-- <td colspan="1" style="border:none;font-weight: bolder; font-size: small;width:0%;padding-right: 25px!important;" class=" br-right br-bottom" >{{data1.invoice_no}}</td> -->
                     <td colspan="1"
    style="border:none;font-weight:bold;font-size:small;"
    class="br-right br-left br-bottom">
    {{ data1.bill_no ? data1.bill_no : data1.invoice_num }}
</td>
                    <td colspan="1" style="border:none ;text-align: end; font-weight: bolder; font-size: small;" class="br-right br-bottom">{{data1.actual_arc_amt}} </td>
                    <td colspan="1" style="border:none ;text-align: end; font-weight: bolder; font-size: small;" class="br-right br-bottom">{{data1.credit_amt}}</td>
                    
                    <td colspan="1" style="border:none;text-align: end; vertical-align: bottom;font-weight: bolder; font-size: small;" class="br-bottom br-right"><ng-container *ngIf="data1.act_amt!=null">{{data1.act_amt}} येणे</ng-container> <br> <span *ngIf="data1?.rem_amount">{{ data1.rem_amount }} येणे</span></td>
                </tr>

                <tr>
                    <td colspan="2" style="border:none;text-align: end;font-weight: bold; font-size: small; border-right:1px solid #000 !important;" class="br-bottom  br-left  br-top"> Invoice Total</td>
                    <td style="text-align: end; font-weight: bold;font-size: medium; border-right:3px solid #000 !important;" class="br-bottom br-left br-right br-top">{{data.invoice_total}}</td>
                    <td colspan="5" class="br-bottom  br-right br-top"></td>
                    <td style="text-align: end; font-weight: bold;font-size: medium;" class="br-bottom  br-right br-top">{{data.total_rcpt_amt}}</td>
                    <td style="text-align: end; font-weight: bold;font-size: medium;" class="br-bottom br-right br-top">{{data.total_credit_amt}}</td>
                     <td style="text-align: end;" class="br-bottom  br-right br-top"></td> 
                </tr>

                <tr >
                    <td colspan="2" style="border:none;text-align: end;font-weight: bold; font-size: small; border-right:1px solid #000 !important;" class="br-bottom  br-left br-top">Total</td>
                    <td colspan="1" style="border:none;text-align: end; font-weight: bold; font-size: small;border-right:3px solid #000 !important;" class="br-bottom br-left br-right br-top ">{{data.invoice_total1}}</td>
                    <td colspan="5" style="border:none; font-weight: bold; font-size: medium;" class="br-bottom br-right br-top"></td>
                    <td colspan="2" style="border:none;text-align: end;font-weight: bold; font-size: medium;" class="br-bottom br-top br-right">{{data.rcv_total}}</td>
                    <td colspan="1" style="border:none;text-align: end;font-weight: bold; font-size: small;" class="br-bottom br-top br-right">{{balancecfamt}}</td>
                   </tr>
                   <tr>
                    <td colspan="2" style="border:none;font-weight: bold; font-size: medium; border-right:1px solid #000 !important;" class="br-bottom br-left ">Balance C/F</td>
                    <td colspan="1" style="border:none;text-align: end;font-weight: bold; border-right:3px solid #000 !important;font-size: medium;" class="br-bottom br-right">{{balancecfamt}}</td>
                    <td colspan="1" style="border:none;font-weight: bold;text-align: start; font-size: small;" class="br-bottom br-right ">येणे</td>
                    <td colspan="8" style="border:none;font-weight: bold; font-size: small;" class="br-bottom br-right"></td>
                   </tr>
            </tbody>
            <tfoot></tfoot>  
        </table>
    </div>

    <div style="margin-left: 70%; margin-bottom: 2%;">
          <button class="noPrint" style="margin-top: 2%; margin-left: 2%" (click)="exportExcel('Contract_InDetails_Report')"
            mat-raised-button color="primary">
            Export
        </button>
       <button 
  class="noPrint" 
  style="margin-top: 2%; margin-right: 10px;" 
  mat-raised-button 
  color="primary" 
  (click)="printPageA4Landscape()">
  Print
</button>
        <button class="noPrint" style="margin-top: 2%;" mat-button mat-dialog-close>
            Close
        </button>
    </div>
    
</div>



<div *ngIf="reportType == 'briefly-booksellerledger'">

    <div class="action-buttons">
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" (click)="exportExcel('Contract_InDetails_Report')"
            mat-raised-button color="primary">
            Export
        </button>
         <button 
  class="noPrint" 
  style="margin-top: 2%; margin-right: 10px;" 
  mat-raised-button 
  color="primary" 
  (click)="printPageA4Portrait() ">
  Print
</button>

    
        <button class="noPrint" style="margin-top: 2%;" mat-button mat-dialog-close>
            Close
        </button>
    </div>

    <div class="container" id="print-section">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="7" class="text-center header-title" style="font-size: 16px;width:0%;">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक                          दिनांक: {{ currentDate | date: 'dd-MM-yyyy' }}</th>
                    <!-- <th colspan="2" class="text-center header-title" style="font-size: 14px;">दिनांक: {{ currentDate | date: 'dd-MM-yyyy' }}</th> -->
                    <!-- <th colspan="2" class="text-center header-title" style="font-size: 16px;">पृष्ठ क्र</th> -->
                </tr>
                <tr>
                   <th colspan="7" style="font-size:14px; padding:5px;">
  <div style="display:flex; justify-content:space-between; align-items:center; width:100%;">
    <span style="flex:1; text-align:center;">Book Seller Ledger - In Brief</span>
    <span style="text-align:right; white-space:nowrap;">
      From {{startDate}} To {{endDate}}
    </span>
  </div>
</th>

                    <!-- <th colspan="">To {{endDate}}</th> -->
                    <!-- <th colspan="2">In Briefly</th> -->
                </tr>
                <tr>
                    <!-- <th>Sr.no</th> -->
                    <th style="width:0%;">Book Seller Name</th>
                    <th>Opening<br>Balance</th>
                    <th>Billing<br>Amount</th>
                    <th>Received<br>Amount</th>
                    <th style="width:0%;">Credit Note<br>Amount</th>
                    <th  style="width:0%;">Total<br>Amount</th>
                    <th  style="width:0%;">Balance</th>
                    <!-- <th colspan="2">Receipt Date</th> -->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data1 of getpersonalledBridflydata">
                    
                    <!-- <td class="text-left">{{k + 1}}</td> -->

                    <td style="width:0%;" class="text-left">{{data1.book_seller_name}}</td>
                    <td class="text-right"style="width:0%;">{{data1.opening_bal}}</td>
                    <td class="text-right"style="width:0%;">{{data1.net_amt}}</td>
                    <td class="text-right"style="width:0%;">{{data1.rcv_amt}}</td>
                    <td class="text-right" style="width:0%;">{{data1.credit_amt}}</td>
                    <td  style="width:0%;"class="text-right">{{data1.total_received_amt}}</td>
                    <td style="width:0%;" class="text-right">{{data1.bal_amt}}</td>
                    <!-- <td colspan="2">येणे</td> -->
                </tr>
            </tbody>
            <tfoot>
                <!-- <tr>
                    <td>Total</td>
                    <td class="text-right">{{Totalop}}</td>
                    <td class="text-right">{{this.Totalnet}}</td>
                    <td class="text-right">{{this.Totalrcv}}</td>
                    <td class="text-right">{{this.TotalCredit}}</td>
                    <td class="text-right">{{TotalCreditTotal}}</td>
                    <td class="text-right">{{Totalbal}}</td>
                    <td class="text-right">{{totalbalance}}</td>
                    <td colspan="2">येणे</td>
                </tr> -->
            </tfoot>

            <tr class="total-row">
                <td><strong style="font-size: 14px;">Total</strong></td>
                <td class="text-right"><strong style="font-size: 14px;">{{Totalop}}</strong></td>
                <!-- <td class="text-right"><strong style="font-size: 14px;"></strong></td> -->
               
                <td class="text-right"><strong style="font-size: 14px;">{{this.Totalnet}}</strong></td>
                <td class="text-right"><strong style="font-size: 14px;">{{this.Totalrcv}}</strong></td>
                <td class="text-right"><strong style="font-size: 14px;">{{this.TotalCredit}}</strong></td>
                <td class="text-right"><strong style="font-size: 14px;">{{TotalCreditTotal}}</strong></td>
                <td class="text-right"><strong style="font-size: 14px;">{{Totalbal}}</strong></td>
                <!-- <td colspan="2"><strong style="font-size: 14px;">येणे</strong></td> -->
            </tr>
            
        </table>
    </div>

    
</div>